import {
  commentsFetchingStart,
  commentsFetchingSuccess,
  commentsFetchingFailure,
  deleteCommentStart,
  deleteCommentSuccess,
  deleteCommentFailure,
} from "./commentSlice";

import {
  fetchNotificationStart,
  fetchNotificationSuccess,
  fetchNotificationFailure,
  createNotificationStart,
  createNotificationSuccess,
  createNotificationFailure,
  switchStateNotificationStart,
  switchStateNotificationSuccess,
  switchStateNotificationFailure,
} from "./notifSlice";

import axios from "axios";
import { publicRequest, userRequest } from "../requestMethods";

export const getComments = async (videoId, dispatch) => {
  dispatch(commentsFetchingStart());
  try {
    const res = await publicRequest.get(`/comments/${videoId}`);
    dispatch(commentsFetchingSuccess(res.data));
  } catch {
    dispatch(commentsFetchingFailure());
  }
};

export const deleteComment = async (commentId, dispatch) => {
  dispatch(deleteCommentStart());
  try {
    await userRequest.delete(`/comments/${commentId}`);
    dispatch(
      deleteCommentSuccess(
        { message: "comment has been deleted !!" },
        commentId
      )
    );
  } catch (err) {
    dispatch(deleteCommentFailure());
  }
};

/*****************NOTIFICATIONS*****************************/

export const getNotif = async (dispatch) => {
  dispatch(fetchNotificationStart());
  try {
    const res = await userRequest.get(`/users/getallnotifs`);
    dispatch(fetchNotificationSuccess(res.data));
  } catch (err) {
    dispatch(fetchNotificationFailure());
  }
};

export const createNotif = async (dispatch, videoId) => {
  dispatch(createNotificationStart());
  try {
    const res = await userRequest.post(`/users/createnotif/${videoId}`);
    dispatch(createNotificationSuccess(res.data));
  } catch (err) {
    dispatch(createNotificationFailure());
  }
};

export const switchNotifState = async (dispatch, notificationId) => {
  dispatch(switchStateNotificationStart());
  try {
    const res = await userRequest.put(`/users/switchnotif/${notificationId}`);
    dispatch(switchStateNotificationSuccess(res.data));
  } catch (err) {
    dispatch(switchStateNotificationFailure());
  }
};

export const changeNotifState = async (userId) => {
  try {
    const res = await userRequest.put(`/users/changenotif/${userId}`);
    res.status(200).json("all notification updated");
  } catch (err) {
    console.log(err);
  }
};
